import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.spacing[2]};
    right: ${({ theme }) => theme.spacing[2]};
    z-index: 1000;
    background-color: ${({ theme }) => theme.colors.gray000};
    padding: ${({ theme }) => theme.spacing[2]};
    border-radius: ${({ theme }) => theme.borderRadius.default};
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.shadow.small};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.secondary600};
`;
